module.exports = __webpack_public_path__ + "img/wxQrCode.e403cdc1.jpg";